import { TableCell, TableRow } from '@mui/material'
import cn from 'classnames'
import React from 'react'
import config from '../../config.json'
import Link from '../common/util/input/Link'
import { formatPercentage, formatUSD, formatWAX } from '../helpers/FormatLinks'
import PreviewGraphic from '../previews/PreviewGraphic'

const CollectionRankingElement = (props) => {
    const index = props['index']

    const target = props['target']

    const { collection, stats } = props['volume']

    const { displayName, name, image } = collection

    const { waxVolume, usdVolume, change, sales } = stats

    const color =
        parseFloat(change) > 0
            ? 'text-green-600'
            : parseFloat(change * 100) < 0
            ? 'text-red-600'
            : 'text-white '

    const link = (children) => {
        return <Link href={`${target}${name}`}>{children}</Link>
    }

    const textClass = cn('px-2 py-4 dark:!text-white text-black ')

    return (
        <TableRow
            key={'ranking-detail-row' + index}
            className={cn(
                'text-white hover:text-primary hover:font-bold hover:bg-zinc-300 dark:hover:!bg-paperl transition-colors duration-300',
            )}
        >
            <TableCell
                className={cn(
                    textClass,

                    index + 1 <= 3 ? 'text-[#F6C30D]' : 'text-white',
                    'text-left',
                )}
            >
                <p className="font-sans">{link(index + 1)}</p>
            </TableCell>
            <TableCell className={cn('text-left px-4 py-2')}>
                {link(
                    <PreviewGraphic
                        hash={image}
                        collection={collection.name}
                        size={240}
                    />,
                )}
            </TableCell>
            <TableCell className={cn(textClass, 'text-left')}>
                <p className="font-sans">{link(displayName)}</p>
            </TableCell>
            <TableCell className={cn(textClass, 'text-middle')}>
                <p className="font-sans">
                    {waxVolume.toFixed(2)} {''} WAX{' '}
                </p>
            </TableCell>
            <TableCell className={cn(textClass, 'text-middle')}>
                <p className="font-sans"> {link(formatUSD(usdVolume))} </p>
            </TableCell>
            <TableCell className={cn(textClass, 'text-right', color)}>
                <div className="flex items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                    >
                        <path
                            d={
                                change > 0
                                    ? 'M5.96131 0.78125L11 6.78125L0.922615 6.78125L5.96131 0.78125Z' // Upward orientation for positive change
                                    : 'M5.03869 6.21875L0 0.21875L10.0774 0.21875L5.03869 6.21875Z'
                            } // Downward orientation for negative change
                            fill={change > 0 ? '#34D399' : '#EF4444'}
                        />
                    </svg>
                    <p
                        className={cn('font-sans', {
                            'ml-2': change < 0,
                            'ml-3': change >= 0,
                        })}
                    >
                        {link(formatPercentage(change * 100))}
                    </p>
                </div>
            </TableCell>

            <TableCell className={cn(textClass, 'text-right')}>
                <p className="font-sans">
                    {link(sales.toLocaleString(undefined))}
                </p>
            </TableCell>
        </TableRow>
    )
}

export default CollectionRankingElement
